module.exports = __webpack_public_path__ + "static/media/customizable.00d56499.svg";